(function () {
  // Unread tracking is keyed on the metaobject id (not the date), so a
  // notification still triggers the dot even when its "date" field is empty,
  // and there is no date-format comparison to get wrong.
  var STORAGE_KEY = 'ff-notif-seen-ids';

  function readSeen() {
    try {
      var arr = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(arr) ? arr : [];
    } catch (e) {
      return [];
    }
  }

  function writeSeen(ids) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
    } catch (e) {}
  }

  function itemIds(el) {
    var ids = [];
    el.querySelectorAll('.notification-item').forEach(function (item) {
      var id = item.getAttribute('data-id');
      if (id) ids.push(id);
    });
    return ids;
  }

  function update(el) {
    var bubble = el.querySelector('.notification-count-bubble');
    if (!bubble) return;

    var seen = readSeen();
    var unread = 0;
    itemIds(el).forEach(function (id) {
      if (seen.indexOf(id) === -1) unread++;
    });

    var count = bubble.querySelector('span[aria-hidden="true"]');
    if (unread > 0) {
      if (count) count.textContent = unread < 100 ? unread : '99+';
      bubble.hidden = false;
    } else {
      bubble.hidden = true;
    }
  }

  function markSeen(el) {
    var seen = readSeen();
    itemIds(el).forEach(function (id) {
      if (seen.indexOf(id) === -1) seen.push(id);
    });
    writeSeen(seen);
    update(el);
  }

  function init() {
    document.querySelectorAll('details-modal.notification-bell').forEach(function (el) {
      update(el);
      var summary = el.querySelector('summary');
      if (summary) {
        summary.addEventListener('click', function () {
          var details = el.querySelector('details');
          if (details && !details.hasAttribute('open')) markSeen(el);
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
